module.exports = "<ul class=\"d-flex flex-wrap m-0 list-unstyled chip\"><li class=\"px-1 mb-1\" ng-repeat=\"item in $ctrl.result track by $index\"><div class=\"d-flex align-items-center chip__item\"><span class=chip__name>{{item}}</span> <i class=\"material-icons chip__close\" ng-click=$ctrl.removeItem($index)>clear</i></div></li><input class=\"gmc-form-control chip__input\" ng-model=$ctrl.newItem ng-keypress=$ctrl.onInputKeypress($event) ng-keyup=$ctrl.onInputKeyup($event) placeholder={{::$ctrl.placeholder}}></ul>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-chips/gmc-chips.component.html
// module id = 538
// module chunks = 31